import { apiRequest } from './axiosConfig';
import { getAdClickIds, reserveEventId } from '../../utils/metaPixel';

export interface TrialRegisterRequest {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
  company_name: string;
  invitation_code?: string;
}

export interface TrialRegisterResponse {
  user: {
    id: number;
    name: string;
    email: string;
    onboarding_completed: boolean;
  };
  token: string;
  refresh_token?: string;
  trial_ends_at: string;
}

export interface TrialStatusResponse {
  is_in_trial: boolean;
  days_remaining: number;
  trial_ends_at: string | null;
  trial_started_at: string | null;
  has_subscription: boolean;
  // Stripe Subscription の status が 'trialing' のときだけ true。
  // 「有料契約中だが Stripe trial 期間中」を判別するために使う (TrialBanner で
  // active な有料ユーザーに誤って trial 表示しないため)。
  is_stripe_trialing?: boolean;
  // OnboardingV2 リリース前から存在する組織だけ true。動画広告・漫画広告の
  // カード登録ロックを免除する（ロック導入前と同じ挙動に戻す）。
  card_lock_exempt?: boolean;
}

const trialService = {
  register: async (data: TrialRegisterRequest): Promise<TrialRegisterResponse> => {
    // 広告のクリック識別子と event_id を一緒に送る。サーバーが Conversions API から
    // 同じ event_id で CompleteRegistration を撃つので、ブラウザ側の fbq が
    // 広告ブロッカー等で落ちても成果が欠けない（届いた場合は Meta 側で1件に丸められる）。
    const payload = {
      ...data,
      ...getAdClickIds(),
      event_id: reserveEventId('CompleteRegistration'),
    };
    const response = await apiRequest.post<TrialRegisterResponse>('trial/register', payload);
    return response;
  },

  getTrialStatus: async (): Promise<TrialStatusResponse> => {
    const response = await apiRequest.get<TrialStatusResponse>('users/trial-status');
    return response;
  },
};

export default trialService;
